/**
 * Whether the product details dialog uses the tabbed dealer view.
 *
 * A platform admin always sees it (MOT-459); `isPlatformAdmin` is the
 * effective role, so it is false while the admin is impersonating, and then
 * the gate follows the acting store exactly as it does for that store's users:
 * on when the store's `dealer_product_view` flag (and plan) is on. Vendors
 * never see it.
 */
export function shouldShowDealerProductView(input: {
  flagEnabled: boolean;
  isStoreScoped: boolean;
  isVendor: boolean;
  isPlatformAdmin: boolean;
}): boolean {
  if (input.isVendor) return false;
  if (input.isPlatformAdmin) return true;
  return input.flagEnabled && input.isStoreScoped;
}

/**
 * The plan-lock notice applies only to a store session. A vendor never gets
 * the dealer view, and a platform admin outside impersonation always does
 * (MOT-459). While impersonating, `isPlatformAdmin` is false, so the lock
 * follows the store.
 */
export function dealerPlanLockApplies(input: {
  isStoreScoped: boolean;
  isVendor: boolean;
  isPlatformAdmin: boolean;
}): boolean {
  return input.isStoreScoped && !input.isVendor && !input.isPlatformAdmin;
}
